import React from 'react'
import AdminList from '../../components/superAdmin/admins/AdminList'

function AdminListPage() {
  return (
    <div>
      <AdminList />
    </div>
  )
}

export default AdminListPage